const Routes = [
  {
    path: '/user-api',
    name: 'UserApi',
    component: () => import('@/app/user_api/TheUserApi'),
    redirect: '/user-api/',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        component: () => import('@/app/user_api/views/Index'),
        name: 'UserApiIndex'
      }
    ]
  }
]

export default Routes



// WEBPACK FOOTER //
// ./src/app/user_api/Routes.js